import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import type {RootState} from './Store';

const dropdownData = {
	second: [
		'PAB',
		'PBNA',
		'PAF',
		'Europe',
		'PFNA',
		'AMESA',
		'APAC',
		'Corporate',
		'LATAM',
	],
	third: ['Travel and Entertainment', 'Contractor and Temp Labor'],
};

const createInitialCheckboxState = (options: string[]) => {
	return options.reduce((acc, option) => {
		acc[option] = false;
		return acc;
	}, {} as Record<string, boolean>);
};

// --- Define the shape of the state ---
interface DropdownState {
	firstValue: string;
	secondValues: Record<string, boolean>;
	thirdValues: Record<string, boolean>;
}

// --- Set the initial state ---
const initialState: DropdownState = {
	firstValue: '',
	secondValues: createInitialCheckboxState(dropdownData.second),
	thirdValues: createInitialCheckboxState(dropdownData.third),
};

// --- Create the slice ---
export const dropdownSlice = createSlice({
	name: 'dropdown',
	initialState,
	reducers: {
		// Action to set the first dropdown's value
		setRole: (state, action: PayloadAction<string>) => {
			state.firstValue = action.payload;
			// Reset dependent states
			state.secondValues = createInitialCheckboxState(dropdownData.second);
			state.thirdValues = createInitialCheckboxState(dropdownData.third);
		},
		// Action to toggle a checkbox in the second dropdown
		toggleSector: (state, action: PayloadAction<string>) => {
			const option = action.payload;
			state.secondValues[option] = !state.secondValues[option];
		},
		// Action to toggle a checkbox in the third dropdown
		toggleCategory: (state, action: PayloadAction<string>) => {
			const option = action.payload;
			state.thirdValues[option] = !state.thirdValues[option];
		},
	},
});

// --- Export actions and selectors ---
export const {setRole, toggleSector, toggleCategory} = dropdownSlice.actions;

export const selectDropdownState = (state: RootState) => state.dropDownDetails;

export default dropdownSlice.reducer;
